import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({
    children,
    delay = 0,
    y = 28,
    className,
    ...rest
}) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.75, delay, ease: EASE }}
        className={className}
        {...rest}
    >
        {children}
    </motion.div>
);

export const Chapter = ({ index, label, title, copy, testid }) => (
    <div data-testid={testid} className="mb-14 md:mb-20">
        <Reveal>
            <div className="flex items-center gap-5">
                <span className="font-display text-sm italic text-brand-accent">
                    ({index})
                </span>
                <span className="text-xs font-bold uppercase tracking-[0.3em] text-brand-muted">
                    {label}
                </span>
                <span aria-hidden className="h-px flex-1 bg-brand-border" />
            </div>
        </Reveal>
        <div className="mt-8 flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
            <Reveal delay={0.08}>
                <h2 className="font-display max-w-3xl text-balance text-4xl font-medium leading-[1.05] tracking-tight text-brand-text md:text-6xl">
                    {title}
                </h2>
            </Reveal>
            {copy && (
                <Reveal delay={0.16}>
                    <p className="max-w-md text-base leading-relaxed text-brand-muted md:text-lg">
                        {copy}
                    </p>
                </Reveal>
            )}
        </div>
    </div>
);
